export default __webpack_public_path__ + "static/media/finger_paintregular.00e5b24a.txt";